import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

export function CancelHotelBooking({
  open,
  closeDrawer,
}: {
  open: boolean;
  closeDrawer: () => void;
}) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <ConfirmDrawer
      open={open}
      onClose={closeDrawer}
      onConfirm={() => {
        navigate({ to: "/" });
      }}
      title={intl.formatMessage({
        defaultMessage: "Cancel hotel booking",
        description: "Button / heading to cancel an existing hotel booking",
      })}
      description={intl.formatMessage({
        defaultMessage: "Are you sure you want to cancel booking?",
        description:
          "Confirmation prompt asking the user to confirm cancellation of a hotel booking",
      })}
      closeLabel={intl.formatMessage({
        defaultMessage: "Back",
        description: "Button to navigate back to the previous screen",
      })}
      confirmLabel={intl.formatMessage({
        defaultMessage: "Cancel",
        description: "Generic 'Cancel' button label",
      })}
    />
  );
}
